
    var riot = require('riot')
    //src: starling/src/tags/undo-banner.html
riot.tag2('undo-banner',
  '<div if="{!opts.operation.isLoggedOut() && undoBanner.open}" onmouseenter="{handleUndoMouseEnter}" onmouseleave="{handleUndoMouseLeave}" class="undo-banner"> <i class="undo-banner_icon material-icons">delete</i> <span> {undoBanner.deletedNodeCount > 0 ? undoBanner.deletedNodeCount : \'\'} {undoBanner.deletedNodeCount > 0 ? \'card\' : \'\'}{undoBanner.deletedNodeCount > 1 ? \'s\' : \'\'} {undoBanner.deletedNodeCount > 0 && undoBanner.deletedLinkCount > 0 ? \'and\' : \'\'} {undoBanner.deletedLinkCount > 0 ? undoBanner.deletedLinkCount : \'\'} {undoBanner.deletedLinkCount > 0 ? \'relationship\' : \'\'}{undoBanner.deletedLinkCount > 1 ? \'s\' : \'\'} {undoBanner.deletedLinkCount + undoBanner.deletedNodeCount > 1 ? \'have\': \'has\'} been deleted </span> <span class="undo-banner_shortcut-hint">{shortcut}</span> <span class="undo-banner_button" onclick="{undoClick}" data-tip="{shortcut}">Undo</span> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _opts = opts,
    canvas = _opts.canvas,
    operation = _opts.operation;
var isMac = canvas.isMac;

this.shortcut = isMac ? '⌘Z' : 'Ctrl+Z';

this.undoBanner = canvas.undoBanner;

this.undoClick = function () {
  if (canvas.isViewOnly()) return;
  _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return operation.undo();

          case 2:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }))();
  canvas.closeUndoBanner();
};

this.handleUndoMouseEnter = function () {
  clearTimeout(canvas.undoBannerTimeout);
};

this.handleUndoMouseLeave = function () {
  canvas.undoBannerTimeout = setTimeout(canvas.closeUndoBanner, _constants.UNDO_BANNER_MOUSEOUT_TIMEOUT);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('undo-banner')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/undo-banner.html
// module id = 664
// module chunks = 0